import { importStaticOrFromLocal } from 'utils';

export const COMMON_LINKS = ({ isLoggedIn = false }: { isLoggedIn: boolean }) => [
  {
    text: isLoggedIn ? 'My Resume' : 'Resume Builder',
    href: isLoggedIn ? '/my-resume/' : '/resume-builder/',
  },
  {
    text: 'Career Quiz',
    href: '/career-quiz/',
  },
  {
    text: 'Career Advice',
    href: '/advice/',
  },
  {
    text: 'Explore Majors',
    href: '/colleges-and-majors/',
  },
  {
    text: 'Questions And Answers',
    href: '/answers/',
  },
  {
    text: 'Interview Questions',
    href: '/advice/interview-questions/',
  },
];

export const JOBS_LINKS = [
  {
    title: 'Explore Jobs',
    links: [
      {
        text: 'Jobs Near Me',
        href: '/jobs/',
      },
      {
        text: 'Remote Jobs',
        href: '/jobs/remote-jobs/',
      },
      {
        text: 'Full Time Jobs',
        href: '/jobs/full-time-jobs/',
      },
      {
        text: 'Part Time Jobs',
        href: '/jobs/part-time-jobs/',
      },
      {
        text: 'Entry Level Jobs',
        href: '/jobs/entry-level-jobs/',
      },
      {
        text: 'Work From Home Jobs',
        href: '/jobs/work-from-home-jobs/',
      },
    ],
  },
  {
    title: 'Find Specific Jobs',
    links: [
      {
        text: '$15 Per Hour Jobs',
        href: '/jobs/15-per-hour-jobs/',
      },
      {
        text: '$20 Per Hour Jobs',
        href: '/jobs/20-per-hour-jobs/',
      },
      {
        text: 'Hiring Immediately Jobs',
        href: '/jobs/hiring-immediately-jobs/',
      },
      {
        text: 'High School Jobs',
        href: '/job-search/high-school-jobs/',
      },
      {
        text: 'H1b Visa Jobs',
        href: '/job-search/foreign-worker-jobs/',
      },
      {
        text: 'LGBTQ Jobs',
        href: '/job-search/lgbtq-jobs/',
      },
      {
        text: 'View All',
        href: '/jobs/',
      },
    ],
  },
  {
    iconList: true,
    links: [
      {
        icon: importStaticOrFromLocal('/ui-router/images/jobs-match-icon.svg'),
        color: '#009688',
        text: 'Match with your dream job now!',
        href: '/matches/',
      },
      {
        icon: importStaticOrFromLocal('/ui-router/images/chrome-extension.svg'),
        color: '#FF9800',
        text: 'Organize Jobs with Zippia Extension!',
        href: '/job-tracker/',
      },
    ],
  },
];

export const CAREER_LINKS = [
  {
    title: 'Explore Careers',
    links: [
      {
        text: 'Sales',
        href: '/sales-industry/',
      },
      {
        text: 'Healthcare',
        href: '/healthcare-practitioner-and-technical-industry/',
      },
      {
        text: 'Business And Financial',
        href: '/business-and-financial-industry/',
      },
      {
        text: 'Architecture And Engineering',
        href: '/architecture-and-engineering-industry/',
      },
      {
        text: 'Computer And Mathematical',
        href: '/computer-and-mathematical-industry/',
      },
      {
        text: 'View All',
        href: '/careers/#jobs-by-industry',
      },
    ],
  },
  {
    title: 'Explore Professions',
    links: [
      {
        text: 'Salaries',
        href: '/salaries/',
      },
      {
        text: 'What They Do',
        href: '/careers/what-they-do/',
      },
      {
        text: 'Certifications',
        href: '/careers/certifications/',
      },
      {
        text: 'Skills',
        href: '/careers/skills/',
      },
      {
        text: 'Education',
        href: '/careers/education/',
      },
      {
        text: 'Demographics',
        href: '/careers/demographics/',
      },
      {
        text: 'View All',
        href: '/careers/',
      },
    ],
  },
  {
    iconList: true,
    links: [
      {
        icon: importStaticOrFromLocal('/ui-router/images/career-take-quiz-icon.svg'),
        color: '#9C27B0',
        text: 'Take the career quiz today!',
        href: '/career-quiz/?step=holland-question1',
      },
      {
        icon: importStaticOrFromLocal('/ui-router/images/chrome-extension.svg'),
        color: '#FF9800',
        text: 'Organize Jobs with Zippia Extension!',
        href: '/job-tracker/',
      },
    ],
  },
];

export const COMPANIES_LINKS = [
  {
    title: 'Best Companies',
    links: [
      {
        text: 'Health Care',
        href: '/company/health-care/#best-companies-to-work-for',
      },
      {
        text: 'Media',
        href: '/company/media/#best-companies-to-work-for',
      },
      {
        text: 'Start-Up',
        href: '/company/start-up/#best-companies-to-work-for',
      },
      {
        text: 'Non-profit',
        href: '/company/non-profits/#best-companies-to-work-for',
      },
      {
        text: 'Fortune 500',
        href: '/company/fortune-500/#best-companies-to-work-for',
      },
      {
        text: 'View All',
        href: '/company/',
      },
    ],
  },
  {
    title: 'Explore Companies',
    links: [
      {
        text: 'Reviews',
        href: '/company/reviews/',
      },
      {
        text: 'Salaries',
        href: '/company/salary/',
      },
      {
        text: 'History',
        href: '/company/history/',
      },
      {
        text: 'Locations',
        href: '/company/locations/',
      },
      {
        text: 'CEO And Executies',
        href: '/company/executives/',
      },
      {
        text: 'View All',
        href: '/company/',
      },
    ],
  },
  {
    iconList: true,
    links: [
      {
        icon: importStaticOrFromLocal('/ui-router/images/companies-hire-talent-icon.svg'),
        color: '#3F51B5',
        text: 'Hire the right talent now',
        href: '/employer/job-posting/job-details/',
      },
      {
        icon: importStaticOrFromLocal('/ui-router/images/chrome-extension.svg'),
        color: '#FF9800',
        text: 'Organize Jobs with Zippia Extension!',
        href: '/job-tracker/',
      },
    ],
  },
];
